import axios from 'axios';
import type { EmployeeBasicInfoDto } from '@zenos/shared-data-access';
import { endpoints } from '../endpoints/employee.endpoint';

export async function getEmployeeDetails(userId?: number) {
  const { data } = await axios.get<EmployeeBasicInfoDto>(
    endpoints.employeeDetails,
    { params: { userId } },
  );

  return data;
}
